import script from "./floatingNotify.vue?vue&type=script&setup=true&lang=js"
export * from "./floatingNotify.vue?vue&type=script&setup=true&lang=js"

import "./floatingNotify.vue?vue&type=style&index=0&id=b7c346d2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7c346d2"]])

export default __exports__